export enum LoggingMessages {
    noCompletedOnPresentOnChallengeParticipation = 'useEngagementData: no completedOn present on completed challenge participation',
    noCompletedOnPresentOnChallengeParticipation2 = 'recommendationsData: find null value in personal recommendations data'
}
